import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=dfd24ef0&"
import script from "./resources.vue?vue&type=script&lang=js&"
export * from "./resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports